const Loading = () => {
	return (
		<div className="h-full w-full flex justify-center items-center">
			<div className="loading bg-black dark:bg-white"></div>
		</div>
	);
}

export default Loading;